/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React__default from 'react';

const LayerContext = /*#__PURE__*/React__default.createContext(1);

export { LayerContext };
